import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DomiciliacionService } from "../../servicios/domiciliacion.service";
import { CatBancosService } from "../../servicios/cat-bancos.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Domiciliacion } from "../../entidades/entidades";
import { CatBancos } from "../../entidades/entidades";
import { CatUsuarios } from "../../entidades/entidades";
import { CatEstatus } from "../../entidades/entidades";
import { PrivilegiosService } from "app/servicios/privilegios.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ROUTES } from "../../sidebar/sidebar.component";

@Component({
  selector: "app-domiciliacion",
  templateUrl: "./domiciliacion.component.html",
  styleUrls: ["./domiciliacion.component.css"]
})


export class DomiciliacionComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catBancos: CatBancos[] = [];
  catUsuarios: CatUsuarios[] = [];
  catEstatus: CatEstatus[] = [];
  domiciliacionForm: FormGroup;
  idAgua: number;
  @Input("domiciliacion") domiciliacion: Domiciliacion;
  @Output("domiciliacionOutput") domiciliacionOutput: EventEmitter<Domiciliacion>;
  privilegios: any[] = [];
  privilegioDomiciliacion: Boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private domiciliacionService: DomiciliacionService,
    private catBancosService: CatBancosService,
    private catEstatusService: CatEstatusService,
    private privilegiosService: PrivilegiosService,
    private route: ActivatedRoute,
  ) {
    this.domiciliacionOutput = new EventEmitter()
  }

  ngOnInit () {
  
   this.getDomiciliacion();
   this.getAllCatBancos();
   this.getAllCatEstatus();
   this.getPrivilegios();
  console.log('this.domiciliacion',this.domiciliacion);

      this.domiciliacionForm = this.formBuilder.group({
        id : [undefined  ],
        idAgua : [undefined  ],
        titular : [undefined  ],
        idBanco : [undefined  ],
        clabe : [undefined  ],
        idEstatus : [undefined  ],
        fecha : [undefined  ],
        dato : [undefined  ],
        idUsuario : [undefined  ],
      });

  }

  async getDomiciliacion() {
    try {
      this.idAgua = this.domiciliacion.idAgua;
      const datoRetorno = await this.domiciliacionService.getBusquedas(this.domiciliacion).toPromise();
      this.domiciliacion = datoRetorno;
      this.domiciliacionForm.patchValue(this.domiciliacion[0]);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllDomiciliacion");
    }
  }


  //====================================================
  //Función de muestra.
  //====================================================
  async guardarDomiciliacion() {
    try {
      if (this.domiciliacionForm.invalid) {throw new Error("No paso las validaciones.");}

      this.domiciliacion  = this.domiciliacionForm.value;
      this.domiciliacion.idAgua = this.idAgua;
      this.domiciliacion.titular = this.domiciliacion.titular.toUpperCase().trim();
      this.domiciliacion.clabe = this.domiciliacion.clabe.trim();
      if (this.domiciliacion.id) {
        this.updateDomiciliacion(this.domiciliacion);
      } else {
        this.domiciliacion.id = 0;
        await this.addDomiciliacion(this.domiciliacion);
      }
      this.domiciliacionOutput.emit(this.domiciliacion);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarDomiciliacion");
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async addDomiciliacion(domiciliacion) {
    try {
      const datoretorno = await this.domiciliacionService.add(domiciliacion).toPromise();
      this.domiciliacion = datoretorno;
      this.domiciliacionForm.patchValue(this.domiciliacion);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addDomiciliacion");
    }
  }

  async updateDomiciliacion(domiciliacion: Domiciliacion) {
    try {
      const datoRetorno = await this.domiciliacionService.update(domiciliacion).toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateDomiciliacion");
    }
  }

async getAllCatBancos() {
    try {
      const datoRetorno = await this.catBancosService.getAll().toPromise();
      this.catBancos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatBancos");
    }
  }

async getAllCatEstatus() {
    try {
      const datoRetorno = await this.catEstatusService.getAll().toPromise();
      const catEstatusAll = datoRetorno;
      this.catEstatus = catEstatusAll.filter(estatus => [1, 4].includes(estatus.id));
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }

  async getPrivilegios() {
    try {
      const datoRetorno = await this.privilegiosService.GetPrivilegiosByUser().toPromise();
      this.privilegios = datoRetorno;
      let moduloRuta = this.privilegios.filter(x => x.path == this.route.snapshot.routeConfig.path);
      this.privilegios = this.privilegios.filter(x => x.idModulo == moduloRuta[0].idModulo);
      this.privilegioDomiciliacion = this.privilegios.some(x => x.path == 'domiciliacion'); 
    
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }
}